export default function Featured() {
  return (
    <section className="relative overflow-hidden py-16 md:py-24">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20cinematic%20dark%20fantasy%20illustration%20of%20a%20heroic%20group%20of%20characters%20walking%20toward%20a%20radiant%20golden%20magic%20portal%20under%20a%20starry%20ink%20sky%2C%20warm%20amber%20glow%2C%20floating%20runes%20and%20particles%2C%20epic%20magic%20adventure%20atmosphere%2C%20manga%20style%2C%20high%20detail&width=1600&height=700&seq=qm-featured-01&orientation=landscape"
          alt="编辑推荐奇妙漫画奇幻冒险作品"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/85 to-background-50/40"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-7xl flex-col items-start px-4 md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/20 px-4 py-1.5 text-sm font-medium text-accent-500">
          <i className="ri-star-smile-line"></i>
          编辑推荐
        </span>
        <h2 className="mt-4 max-w-xl font-heading text-3xl font-bold leading-snug text-foreground-950 md:text-4xl">
          本周编辑精选：<span className="text-primary-500">《破晓异世录》</span>
        </h2>
        <p className="mt-4 max-w-lg text-base leading-relaxed text-foreground-700">
          考古系研究生坠入失落魔法纪元，身怀上古秘术卷轴，在帝国与龙族之间周旋。高能剧情、伏笔环环相扣，本周已有 12 万读者加入追更。
        </p>
        <div className="mt-7 flex flex-col gap-3 sm:flex-row">
          <a
            href="#latest"
            className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
          >
            立即观看 <i className="ri-play-fill"></i>
          </a>
          <a
            href="#subscribe"
            className="inline-flex items-center gap-2 rounded-full border border-background-300 bg-background-100/80 px-7 py-3 text-sm font-medium text-foreground-950 transition-colors hover:border-primary-500 hover:text-primary-500 whitespace-nowrap"
          >
            收藏追更
          </a>
        </div>
      </div>
    </section>
  );
}